module.exports = __webpack_public_path__ + "assets/img/index-product2.bc4c3f7f.png";